( function() {
    'use strict';

    angular
        .module( 'ccsTrApp' )
        .factory( 'LotMinDTO', LotMinDTO );

    LotMinDTO.$inject = [ '$resource', 'DateUtils' ];

    function LotMinDTO( $resource, DateUtils ) {
        var resourceUrl = "api/lotMinDTO/:id";

        return $resource( resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
